/* eslint-disable */
<template>
    <div class="d-flex flex-column align-items-center">
         <div class="datepicker-wrapper">
            <datepicker v-model="date"
                :inline="true"
                :disabled-dates="disabledDates"
                calendar-class="booking-datepicker__calendar"
                maximumView="day"
                calendar-button-icon="far fa-calendar-alt"
                @changedMonth=changedMonth>
            </datepicker>
            <div v-show="loading" class="datepicker-overlay">
                <div class="d-flex">
                    <span class="inline-loader"></span><span class="text-default">fetching...</span>
                </div>
            </div>
        </div>
        <error-banner v-if="error" :message="error" class="mx-3 mt-2"></error-banner>
    </div>
</template>

<script>
/* eslint-disable */
    import moment from 'moment-timezone'
    import { mapMutations } from 'vuex';
    import { AppointmentSearchMixin } from '@/mixins/Booking/AppointmentSearchMixin';
    import { EventSearchMixin } from '@/mixins/Booking/EventSearchMixin';
    import { OneOffHourSearchMixin } from '@/mixins/Booking/OneOffHourSearchMixin';
    import { SelectedDateMixin } from '@/mixins/Booking/SelectedDateMixin';
    import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin';
    import Datepicker from 'vuejs-datepicker';
    import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue';

    export default {
        name: 'DateSelect',
        mixins: [AppointmentSearchMixin, EventSearchMixin, OneOffHourSearchMixin, SelectedDateMixin, SiteBookingSettingMixin],
        computed: {
            date: {
                get() {
                    return this.selectedDate;
                },
                set(value) {
                    this.setSelectedDate(value);
                }
            },
            disabledDates() {
                return { 
                    to: this.datePickerStartDate,
                    days: this.closedDays,
                    from: this.datePickerEndDate
                }
            },
            loading() {
                return !!this.loadingOpeningHours || !!this.loadingAppointments || !!this.loadingOneOffHours
            }
        },
        watch: {
            date() {
                this.clearStartUtc();
            }
        },
        methods: {
            ...mapMutations('BookingUpload', [
                'clearStartUtc'
            ]),
            changedMonth(value) {
                this.setSelectedDate(value > this.datePickerInitialStartDate ? this.findNearestOpenDate(value) : this.datePickerInitialStartDate);
                this.clearStartUtc();
            }
        },
        created() {
            this.refreshBookingSelectedDate();
        },
        components: {
            'error-banner': ErrorBanner,
            Datepicker
        }
    }
</script>

<style scoped>
    .datepicker-wrapper {
        position: relative;
        display: inline-block;
    }
    .datepicker-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: auto;
    }
</style>